/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import NewsletterModel from 'cio/models/newsletter';
import { Task } from 'ember-concurrency';

interface EditorArgs {
  selectedNewsletters?: Record<string, any>;
  disabled?: boolean;
  size?: string;
  selectedNegate?: Record<string, any>;
  newsletters?: NewsletterModel[];
  marginClass?: string;
  dropdownClass?: string;

  updateNewslettersTask?: Task<unknown, []>;
  loadNewslettersNextPageTask?: Task<unknown, []>;
  onNewsletterSelect: () => unknown;
}

export default class Editor extends Component<EditorArgs> {
  negates: Record<string, string | boolean>[] = [
    {
      value: false,
      label: 'is',
    },
    {
      value: true,
      label: 'is not',
    },
  ];
}
